(function(){
  function init(root){
    var bar=root.querySelector('[data-md-sticky]'); if(!bar||bar.dataset.ready) return; bar.dataset.ready='1';
    var link=bar.querySelector('a'), threshold=parseInt(bar.dataset.threshold||'700',10), t=false;
    function target(){ var id=(bar.dataset.target||'md-buy').replace('#',''); return document.getElementById(id); }
    function onScroll(){ if(t) return; t=true; requestAnimationFrame(function(){
      var y=document.documentElement.scrollTop||document.body.scrollTop, off=target(), inView=false;
      if(off){ var r=off.getBoundingClientRect(); inView=r.top<innerHeight && r.bottom>0; }
      var show=y>threshold && !inView;
      bar.classList.toggle('show',show); bar.setAttribute('aria-hidden',show?'false':'true');
      if(link) link.tabIndex=show?0:-1; t=false; }); }
    addEventListener('scroll',onScroll,{passive:true}); onScroll();
    document.addEventListener('md:variant-change',function(e){ var p=bar.querySelector('[data-st-price]'); if(p&&bar.dataset.live==='true') p.textContent=e.detail.price; });
  }
  function all(){ document.querySelectorAll('.md-sticky').forEach(init); }
  if(document.readyState!=='loading') all(); else document.addEventListener('DOMContentLoaded',all);
  document.addEventListener('shopify:section:load',function(e){ var r=e.target.querySelector('.md-sticky'); if(r) init(r); });
})();
